import React from 'react';
import styles from './FAQSection.module.scss';

const FAQSection: React.FC = () => (
  <div className={styles['faq-section']}>
    <div className={styles['faq-title']}>Frequently Asked Questions</div>
    <div className={styles['faq-list']}>
      <div className={styles['faq-item']}>
        <span className={styles['faq-q']}>1.What should I do if the seller doesn't ship the goods?</span>
        <span className={styles['faq-a']}>If the seller delays shipping, you can choose corresponding actions based on the current order status.</span>
      </div>
      <div className={styles['faq-item']}>
        <span className={styles['faq-q']}>2.How do I apply for a refund?</span>
        <span className={styles['faq-a']}>The application method varies depending on the status of your order.</span>
      </div>
      <div className={styles['faq-item']}>
        <span className={styles['faq-q']}>3.After applying for a refund and the transaction refund is successful, where will the money be refunded to?</span>
        <span className={styles['faq-a']}>First, check the refund status. Only when the refund status of the order shows [Refund Successful] will the money be returned to the original payment channel.</span>
      </div>
    </div>
  </div>
);

export default FAQSection; 